var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{attrs:{"id":"myBtn","title":"Go to top"},on:{"click":function($event){return _vm.topFunction()}}},[_c('i',{staticClass:"fa-solid fa-chevron-up"})])])}
var staticRenderFns = []

export { render, staticRenderFns }